import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { colors } from 'packages/common-frontend/colors';

const versionBackgroundColor = colors.aurora[50];
const selectedBackgroundColor = colors.aurora[500];
export const datepickerStyles = {
  // style to use when a date has versions
  '.react-datepicker__day--highlight1': {
    backgroundColor: versionBackgroundColor,
    borderRadius: '50%',
    color: 'black',
  },

  // style to use when date is selected
  '.react-datepicker__day--highlight2': {
    backgroundColor: selectedBackgroundColor,
    borderRadius: '50%',
    color: 'white',
  },
};

type HighlightDates = {
  [key: string]: Date[];
};

export const getHighlightedDates = ({
  selectedDate,
  highlightedDates,
}: {
  selectedDate: Util.FullDateStr | null;
  highlightedDates: Date[];
}): HighlightDates[] => {
  const customHighlightedDates: HighlightDates[] = [
    {
      'react-datepicker__day--highlight1': highlightedDates,
    },
  ];

  if (selectedDate) {
    customHighlightedDates.push({
      'react-datepicker__day--highlight2': [
        commonDate.fullDateStrToDate(selectedDate),
      ],
    });
  }

  return customHighlightedDates;
};

export const Legend = () => {
  return (
    <Box pb={4} display="flex" alignItems="center">
      <Flex alignItems="center" mr={6}>
        <Box
          bg={selectedBackgroundColor}
          w="16px"
          h="16px"
          mr={2}
          borderRadius="50%"
        />
        <Text fontSize="md">Selected Date</Text>
      </Flex>
      <Flex alignItems="center">
        <Box
          bg={versionBackgroundColor}
          w="16px"
          h="16px"
          mr={2}
          borderRadius="50%"
        />
        <Text fontSize="md">Data Tape Previously Uploaded</Text>
      </Flex>
    </Box>
  );
};
